module.exports = __webpack_public_path__ + "img/3.148f107f.png";